export default function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/permute.js
// module id = 309
// module chunks = 0